export default "__VITE_ASSET__CqougbFl__"